import {Module} from "../index";
import messages from "./resources/messages";
import GameSaver from "@/modules/main-menu/services/GameSaver";
import GameLoader from "@/modules/main-menu/services/GameLoader";
import {AutoSaveEventSubscriber} from "@/modules/main-menu/subscribers/AutoSaveEventSubscriber";
import {DatabaseEventSubscriber} from "@/modules/main-menu/subscribers/DatabaseEventSubscriber";
import {routes} from "./resources/routes";

export class MainMenuModule extends Module {
  messages = messages;
  routes = routes;

  public entities = [];

  eventSubscribers = [
    AutoSaveEventSubscriber,
    DatabaseEventSubscriber,
  ];

  protected register() {
    super.register();

    this.app.bind<GameSaver>(GameSaver).to(GameSaver);
    this.app.bind<GameLoader>(GameLoader).to(GameLoader);
  }
}
